import type { EnumUnion } from "@dresscode-frontend/utility-types";

import type { ApiSearchQuery } from "@/lib/api/api-type-helper";

import type { Role, SortableColumns } from "./-types";

type QUERY = ApiSearchQuery<"/v2/settings/permission-and-roles/roles", "get">;
type CATEGORY = Exclude<QUERY, undefined>["category"];
type CATEGORY_KEY = Exclude<CATEGORY, undefined>;

export const TabKey = {
  ALL: "ALL",
  // DEPRECATED: "DEPRECATED",
} as const satisfies Record<CATEGORY_KEY, string>;

export type TabKey = EnumUnion<typeof TabKey>;

export const ROLE_COLUMNS = {
  ROLE_NAME: "roleName",
  TOTAL_PEOPLE: "totalPeople",
  PEOPLE_GROUPS: "peopleGroups",
  PRODUCT_PERMISSIONS: "productPermissions",
} as const satisfies Record<string, keyof Role>;

export type OrderBy = Exclude<QUERY["orderBy"], undefined>;

export const SortColumns = ["ROLE_NAME"] as const satisfies OrderBy[];

export const COLUMNS_TO_SORT_COLUMNS = {
  roleName: "ROLE_NAME",
} as const satisfies Record<SortableColumns, OrderBy>;

export const SORT_COLUMNS_TO_COLUMNS = {
  ROLE_NAME: "roleName",
} as const satisfies Record<OrderBy, SortableColumns>;
